import * as requestFromServer from "./StudentAssignmentCrud";
import { callTypes, studentLevelSectionSlice } from "./StudentAssignmentSlice";

const {actions} = studentLevelSectionSlice;

export const getStudentAndLevelSections = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getStudentAndLevelSections(queryParams)
    .then(response => {
      dispatch(actions.studentsFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllStudentAndLevelSections = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllStudentAndLevelSections(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getStudents = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getStudents(queryParams)
    .then(response => {
      dispatch(actions.studentsFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllLevelCourses = () => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllLevelCourses()
    .then(response => {
      dispatch(actions.allCoursesFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getLevelCourses = grade => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getLevelCourses(grade)
    .then(response => {
      dispatch(actions.coursesFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getLevelSections = courseId => async dispatch => {
  return requestFromServer
    .getLevelSections(courseId)
    .then(response => {
      dispatch(actions.levelSectionsFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getRegistrationInfoIds = sectionId => async dispatch => {
  return requestFromServer
    .getRegistrationInfoIds(sectionId)
    .then(response => {
      dispatch(actions.registrationInfoIdsFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const saveStudents = (sectionId, ids) => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .saveStudents(sectionId, ids)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const removeStudents = ids => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .removeStudents(ids)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const cleanCoursesAndSections = () => dispatch => {
  return dispatch(actions.coursesAndSectionsCleaned());
};

export const cleanStudentLevelSectionState = () => dispatch => {
  return dispatch(actions.studentLevelSectionStateCleaned());
};